import React, { Suspense, Fragment } from 'react';
import routes from './routes';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HtmlParser from 'react-html-parser';
import { faBars, faPlay } from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook, faTwitter, faYoutube, faLinkedinIn, faGooglePlus
} from '@fortawesome/free-brands-svg-icons';
import Topbar, { Header } from './Topbar';
import Application from '../views/Application';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import AutoLogout from './AutoLogout';

const loader = () => <div id="loader"></div>;

const DefaultLayout = () => (
  <div className="container bg-white">
    <NotificationContainer />
    <AutoLogout />
    <Topbar><Header /></Topbar>

    <div style={{minHeight:'58vh'}}>
        <Suspense fallback={loader}>
          <BrowserRouter>
            <Switch>
              {routes.map((route, idx) => {
                return route.component ? (
                  <Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                    <route.component {...props} />
                  )} />
                ) : (null);
              })}
              {<Redirect from="/" to="/introduction" />}
            </Switch>
          </BrowserRouter>
        </Suspense>
    </div>
    {LFooter()}
  </div>
);

const LTitleBar = (props) => (
  <div className="row">
    <div className="col-xs-12">&nbsp;</div>
    <div className="col-xs-12 col-md-3" >&nbsp;</div>
    <div className="col-xs-12 col-md-8 mt-3"><h4>{HtmlParser(props.title)}</h4></div>
    <div className="col-xs-12">&nbsp;</div>
  </div>
);

const LFooter = () => (
  <div className="row">
    <div className="col-xs-12">&nbsp;</div>
    <div className="col-xs-12 col-12 comp-bg" >
      <div className="foot_left">Support! Get Intouch <br /><span>0 3 0 . 2 7 4  . 7 7 7 7 </span></div>
      <div className="foot_right">
        Lets Get Social &nbsp; &nbsp; &nbsp;
        <a className="tips" href="https://web.facebook.com/ghanaenterprisesagency" target="_blank" title="Follow Us on Facebook"><FontAwesomeIcon icon={faFacebook} size="lg" style={{ color: 'white' }} /></a>
        <a className="tips" href="https://twitter.com/gea_ghana" target="_blank" title="Follow Us on Twitter"><FontAwesomeIcon icon={faTwitter} size="lg" style={{ color: 'white' }} /></a>
        <a className="tips" href="https://www.youtube.com/channel/UCXlG7Cneamhe5l7aFjMfS_Q" target="_blank" title="Watch Our Videos"><FontAwesomeIcon icon={faYoutube} size="lg" style={{ color: 'white' }} /></a>
        <a className="tips" href="https://www.linkedin.com/company/national-board-for-small-scale-industries-nbssi/" target="_blank" title="Follow Us on LinkedIn"><FontAwesomeIcon icon={faLinkedinIn} size="lg" style={{ color: 'white' }} /></a>
      </div>
    </div>
    <div className="col-xs-12 col-12">&nbsp;</div>
    <div className="col-xs-12 col-sm-6 col-md-6 text-center">
    HGP - High Growth Programme &copy; 2022, All Rights Reserved
        </div>
    <div className="col-xs-12 col-sm-6 col-md-6 text-center">
      Powered by <a href="#" style={{ color: '#4368ff' }}>GEA</a>
    </div>
    <div className="col-xs-12 col-sm-12">&nbsp;</div>
  </div>
)

DefaultLayout.LFooter = LFooter;
DefaultLayout.LTitleBar = LTitleBar;

export default DefaultLayout;
export { DefaultLayout, LFooter, LTitleBar }